import api from '@/lib/axios';
import type { Paginated } from '@/services/school.api';
import { SliderAudience, SliderRow } from '@/services/school.api';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface UploadResult {
  url: string;
  name: string;
  size: number;
  mime: string;
}

export interface CreateOrgSliderData {
  schoolId: string;
  imageUrl: string;
  link?: string;
  forSlider: SliderAudience;
}

export interface UpdateOrgSliderData {
  schoolId: string;
  imageUrl?: string;
  link?: string;
  forSlider?: SliderAudience;
}

export interface OrgSliderRow extends SliderRow {
  schoolId: string;
  schoolName: string;
}

export const OrgSlidersApi = {
  schools: async (): Promise<{ id: string; name: string }[]> => unwrap(await api.get('/org/sliders/schools')),

  upload: async (schoolId: string, file: File): Promise<UploadResult> => {
    const fd = new FormData();
    fd.append('file', file);
    return unwrap(await api.post('/org/sliders/uploads', fd, { params: { schoolId } }));
  },

  /** Omit schoolId for every school in scope, flat — matches real legacy's own (session-free) list view. */
  list: async (schoolId: string | undefined, params?: { page?: number; limit?: number }): Promise<Paginated<OrgSliderRow>> =>
    unwrap(await api.get('/org/sliders', { params: { ...(schoolId ? { schoolId } : {}), ...params } })),

  create: async (data: CreateOrgSliderData): Promise<SliderRow> => unwrap(await api.post('/org/sliders', data)),

  update: async (id: string, data: UpdateOrgSliderData): Promise<SliderRow> => unwrap(await api.patch(`/org/sliders/${id}`, data)),

  remove: async (id: string, schoolId: string): Promise<void> => unwrap(await api.delete(`/org/sliders/${id}`, { params: { schoolId } })),
};
